import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGER_TYPES } from "../../../API/UserApi";

import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const deleteChargerConnectorTypesAPI: any = createAsyncThunk(
  "deleteStations",
  async (rowId: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.delete(CHARGER_TYPES + "/" + rowId, {
        headers: commonHead,
      });
      return { connectorTypeDeleted: res };
    } catch (error) {
      if (error instanceof Error) {
        return rejectWithValue({ error: error.message });
      }
    }
  }
);
